export default {
  props: {
    photoUrl: {
      type: String,
      default: undefined,
    },
    photoWidth: {
      type: Number,
      default: undefined,
    },
  },
};
